export default "__VITE_ASSET__BzAsbWd7__"